import { render, staticRenderFns } from "./ParcelasCompradasUser.vue?vue&type=template&id=a2bbffa2"
import script from "./ParcelasCompradasUser.vue?vue&type=script&lang=js"
export * from "./ParcelasCompradasUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports